// Reusable product placeholder tile — we don't have the original images yet
import React from "react";
import { Wrench } from "lucide-react";

const ProductPlaceholder = ({ title = "", className = "", subtitle }) => (
  <div className={`jt-placeholder flex flex-col items-center justify-center ${className}`}>
    <Wrench className="w-10 h-10 text-[var(--jt-text-muted)]" strokeWidth={1.4} />
    {title ? (
      <div className="mt-3 font-mono text-[0.65rem] tracking-[0.18em] uppercase text-[var(--jt-text-muted)] text-center max-w-[80%] line-clamp-2">
        {title}
      </div>
    ) : null}
    {subtitle ? (
      <div className="mt-1 font-mono text-[0.55rem] tracking-widest text-[var(--jt-text-muted)]/70">{subtitle}</div>
    ) : null}
  </div>
);

export default ProductPlaceholder;
